import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { customerService } from '../services/customerService.js';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let active = true;
    customerService
      .me()
      .then((payload) => {
        if (active) setCustomer(payload.customer || null);
      })
      .catch(() => {})
      .finally(() => {
        if (active) setStatus('ready');
      });
    return () => {
      active = false;
    };
  }, []);

  const value = useMemo(() => ({
    customer,
    status,
    isAuthenticated: Boolean(customer),
    async login(credentials) {
      const payload = await customerService.login(credentials);
      setCustomer(payload.customer || null);
      return payload;
    },
    async logout() {
      try {
        await customerService.logout();
      } finally {
        setCustomer(null);
      }
    },
    // Account forms return the fresh customer — keep context in sync.
    setCustomer,
  }), [customer, status]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used inside AuthProvider');
  }
  return context;
}
